<div class="pad top-3x bottom-3x left-1x right-1x center">
  <h2 class="text-medium" [innerHTML]="'contact_us' | translate"></h2>

  <p class="my-3.5" [innerHTML]="'contact_us_questions' | translate"></p>

  <mat-icon class="mr-2" svgIcon="dls-phone-light"></mat-icon>

  <span
    class="fs-2rem"
    fxHide.lt-md
    [innerHTML]="'contact_us_phone' | translate"
  >
  </span>

  <span class="fs-2rem" fxHide.gt-sm>
    <a
      href="tel:{{ 'contact_us_phone' | translate }}"
      [innerHTML]="'contact_us_phone' | translate"
    >
    </a>
  </span>

  <p class="my-3.5" [innerHTML]="'contact_us_hours' | translate"></p>
</div>
